import toast from "react-hot-toast";
import * as api from "../Api";

export const createInstitution = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Creating institution...");
    const { data } = await api.createInstitution(postData);
    dispatch({ type: "CREATE_INSTITUTION", payload: data });
    toast.remove(creatingId);
    toast.success("Institution type created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};

export const getAllInstitution = () => async (dispatch) => {
  try {
    const { data } = await api.getInstitution();
    dispatch({ type: "GET_INSTITUTION", payload: data });
  } catch (error) {}
};

export const deleteInstitution = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting institution...");
    await api.deleteInstitution(id);
    dispatch({ type: "NEW_INSTITUTION_TO_BE_DELETED", payload: id });
    toast.remove(deletingId);
    toast.success("Institution type deleted successfully");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
